const padDatePart = (value) => String(value).padStart(2, '0');

export const normalizeBackendDate = (value) => {
  if (!value) {
    return '';
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return [
      value.getFullYear(),
      padDatePart(value.getMonth() + 1),
      padDatePart(value.getDate()),
    ].join('-');
  }

  const rawValue = String(value).trim();

  const isoDateMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoDateMatch) {
    return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
  }

  const backendDateMatch = rawValue.match(/^(\d{1,2})T[^/]*\/(\d{1,2})\/(\d{4})$/);
  if (backendDateMatch) {
    const [, day, month, year] = backendDateMatch;

    return `${year}-${padDatePart(month)}-${padDatePart(day)}`;
  }

  const europeanDateMatch = rawValue.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (europeanDateMatch) {
    const [, day, month, year] = europeanDateMatch;

    return `${year}-${padDatePart(month)}-${padDatePart(day)}`;
  }

  const slashIsoDateMatch = rawValue.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
  if (slashIsoDateMatch) {
    const [, year, month, day] = slashIsoDateMatch;

    return `${year}-${padDatePart(month)}-${padDatePart(day)}`;
  }

  return rawValue;
};

export const formatNormalizedDateForDisplay = (value) => {
  const normalizedDate = normalizeBackendDate(value);
  const [year, month, day] = normalizedDate.split('-');

  if (!year || !month || !day) {
    return normalizedDate;
  }

  return `${day}/${month}/${year}`;
};

export const isDateInRange = (value, startValue, endValue) => {
  const normalizedDate = normalizeBackendDate(value);
  const normalizedStart = normalizeBackendDate(startValue);
  const normalizedEnd = normalizeBackendDate(endValue);

  return normalizedDate >= normalizedStart && normalizedDate <= normalizedEnd;
};
